const requiredFirebaseEnv = [
    "VITE_FIREBASE_API_KEY",
    "VITE_FIREBASE_APP_ID",
    "VITE_FIREBASE_AUTH_DOMAIN",
    "VITE_FIREBASE_MESSAGING_SENDER_ID",
    "VITE_FIREBASE_PROJECT_ID",
    "VITE_FIREBASE_STORAGE_BUCKET"
];
function readEnv(env, key) {
    const value = env[key];
    return typeof value === "string" ? value.trim() : "";
}
function readPort(env, key, fallback) {
    const parsed = Number.parseInt(readEnv(env, key), 10);
    return Number.isFinite(parsed) ? parsed : fallback;
}
function readBooleanFlag(value) {
    if (typeof value === "boolean") {
        return value;
    }
    if (typeof value !== "string") {
        return null;
    }
    const normalized = value.trim().toLowerCase();
    if (["1", "true", "yes", "on"].includes(normalized)) {
        return true;
    }
    if (["0", "false", "no", "off"].includes(normalized)) {
        return false;
    }
    return null;
}
export function readFirebaseClientSettings(env, options = {}) {
    const missingEnv = requiredFirebaseEnv.filter((key) => readEnv(env, key).length === 0);
    const explicitEmulatorFlag = readBooleanFlag(env.VITE_USE_FIREBASE_EMULATORS);
    const useEmulators = explicitEmulatorFlag ?? options.devDefault ?? false;
    const projectId = readEnv(env, "VITE_FIREBASE_PROJECT_ID") || "demo-kajikajy";
    const config = missingEnv.length === 0
        ? {
            apiKey: readEnv(env, "VITE_FIREBASE_API_KEY"),
            appId: readEnv(env, "VITE_FIREBASE_APP_ID"),
            authDomain: readEnv(env, "VITE_FIREBASE_AUTH_DOMAIN"),
            messagingSenderId: readEnv(env, "VITE_FIREBASE_MESSAGING_SENDER_ID"),
            projectId,
            storageBucket: readEnv(env, "VITE_FIREBASE_STORAGE_BUCKET")
        }
        : useEmulators
            ? {
                apiKey: "demo-api-key",
                appId: "demo-app-id",
                authDomain: `${projectId}.firebaseapp.com`,
                messagingSenderId: "000000000000",
                projectId,
                storageBucket: `${projectId}.appspot.com`
            }
            : null;
    return {
        config,
        isConfigured: config !== null,
        missingEnv,
        usesDemoConfig: missingEnv.length > 0 && useEmulators,
        useEmulators,
        emulator: {
            authHost: readEnv(env, "VITE_FIREBASE_AUTH_EMULATOR_HOST") || "127.0.0.1",
            authPort: readPort(env, "VITE_FIREBASE_AUTH_EMULATOR_PORT", 9099),
            firestoreHost: readEnv(env, "VITE_FIRESTORE_EMULATOR_HOST") || "127.0.0.1",
            firestorePort: readPort(env, "VITE_FIRESTORE_EMULATOR_PORT", 8080),
            functionsHost: readEnv(env, "VITE_FIREBASE_FUNCTIONS_EMULATOR_HOST") || "127.0.0.1",
            functionsPort: readPort(env, "VITE_FIREBASE_FUNCTIONS_EMULATOR_PORT", 5001),
            functionsRegion: readEnv(env, "VITE_FIREBASE_FUNCTIONS_REGION") || "us-central1"
        }
    };
}
//# sourceMappingURL=firebase-web-config.js.map